<template>
  <div class="wrapper">
    <div class="animated fadeIn">
      <b-row>
        <b-col>

          <b-row>
            <b-col sm="12">
              <b-card v-if="qn_income==4 || qn_income==3" header-class="redmfu">
                <div slot="header" >
                  <strong v-if="thai_student==1" >ตอนที่ 3 สำหรับผู้ที่ยัง<u>ไม่</u>ได้ทำงาน </strong>
                  <strong v-else>Part 3 For graduates <u>not</u> yet employed</strong>
                  <div style="float:right;">
                    <b-badge pill variant="warning" class="font-sm text-dark p-2 pr-3 pl-3">Session Timeout :
                      {{ this.$store.state.timeExp }}
                    </b-badge>
                  </div>
                </div>
                <div v-for="item in items" v-bind:key="item.QUESTION_PK">
                  <!--                  {{ item.NUMBER }})-->
                  <!--                  &lt;!&ndash;                  {{ item.QUESTION_PK }}. &ndash;&gt;-->

                  <!--                  {{ items2[item.QUESTION_PK-34].VALUES }}-->
                  <b-form-group
                    class="text-danger"
                    v-if="(items2[item.QUESTION_PK-34].VALUES ==2)"
                    :label="'*  ' +item.NUMBER  + ') '+item.QUESTION_NAME"
                    label-for="basicInlineRadios"
                    :label-cols="12"
                  ></b-form-group>
                  <b-form-group
                    v-else
                    :label="item.NUMBER  + ') '+item.QUESTION_NAME"
                    label-for="basicInlineRadios"
                    :label-cols="12"
                  ></b-form-group>
                  <b-form-group
                    label-cols-sm="1"
                    label
                    label-align-sm="right"
                    label-for="nested-street"
                  >
                    <b-form-radio-group
                      v-if="item.QUESTION_PK==34"
                      v-model="selected_cause_nowork"
                      value-field="BYTECODE"
                      text-field="BYTEDES"
                      :options="items[0].ANS"
                      stacked
                      name="selected_cause_nowork"
                    >

                      <b-form-input
                        v-if="selected_cause_nowork=='0'"
                        id="qn_cause_nowork_txt"
                        type="text"
                        autocomplete="qn_cause_nowork_txt"
                        v-model="qn_cause_nowork_txt"
                        placeholder="Other..."
                      ></b-form-input>
                    </b-form-radio-group>
                    <b-form-radio-group
                      v-if="item.QUESTION_PK==35 && thai_student==0 && ( selected_prob_findwork=='' || length !=0)"
                      v-model="selected_prob_findwork_20"
                      value-field="BYTECODE"
                      text-field="BYTEDES"
                      :options="items_findwork_eng"
                      @change="onchangeFindwork"
                    ></b-form-radio-group>
                    <b-form-radio-group
                      v-if="item.QUESTION_PK==35 && thai_student==1 &&  ( selected_prob_findwork=='' || length !=0)"
                      v-model="selected_prob_findwork_20"
                      value-field="BYTECODE"
                      text-field="BYTEDES"
                      @change="onchangeFindwork"
                      :options="items_findwork_thai"
                    ></b-form-radio-group>
                    <strong v-if="item.QUESTION_PK==35  && selected_prob_findwork_20==2 && thai_student==0 ">(If yes,
                      please choose the reasons. You can choose more than one
                      answer.)</strong>
                    <strong v-if="item.QUESTION_PK==35  && selected_prob_findwork_20==2 && thai_student==1 ">(หากตอบมีปัญหา
                      โปรดระบุปัญหา โดยสามารถเลือกตอบได้หลายข้อ)
                    </strong>
                    <!--                    {{ selected_prob_findwork_20 }}  {{ selected_prob_findwork }}-->
                    <b-form-checkbox-group
                      v-if="item.QUESTION_PK==35 && selected_prob_findwork_20==2"
                      v-model="selected_prob_findwork"
                      value-field="BYTECODE"
                      text-field="BYTEDES"
                      :options="items[1].ANS"
                      stacked
                      name="selected_prob_findwork"
                    >
                      <b-form-input
                        id="qn_prob_findwork_txt"
                        type="text"
                        autocomplete="qn_prob_findwork_txt"
                        v-model="qn_prob_findwork_txt"
                        placeholder="Other..."
                      ></b-form-input>
                    </b-form-checkbox-group>

                    <b-form-radio-group
                      v-if="item.QUESTION_PK==36"
                      v-model="selected_workneed_id"
                      value-field="BYTECODE"
                      text-field="BYTEDES"
                      :options="items[2].ANS"
                      stacked
                      name="selected_workneed_id"
                    >
                    </b-form-radio-group>
                  </b-form-group>
                </div>
              </b-card>
              <b-card v-if="selected_workneed_id==1">
                <div slot="header" >
                  <strong v-if="thai_student==1" >ตอนที่ 3 สำหรับผู้ที่ยังไม่ได้ทำงาน <u>และทำงานในประเทศ</u></strong>
                  <strong v-else>Part 3 For graduates not yet employed <u>and work in my own country </u> </strong>
                </div>
                <div v-for="item1 in item1s" v-bind:key="item1.QUESTION_PK" v-if="item1.QUESTION_PK > 37">
                  <b-form-group
                    class="text-danger"
                    v-if="(items2[item1.QUESTION_PK-34].VALUES ==2)"
                    :label="'*  ' +item1.NUMBER2+ ') '+item1.QUESTION_NAME"
                    label-for="basicInlineRadios"
                    :label-cols="12"
                  ></b-form-group>
                  <b-form-group
                    v-else
                    :label="item1.NUMBER2+ ') '+item1.QUESTION_NAME"
                    label-for="basicInlineRadios"
                    :label-cols="12"
                  ></b-form-group>
                  <b-form-group
                    label-cols-sm="1"
                    label
                    label-align-sm="right"
                    label-for="nested-street"
                  >
                    <v-select
                      v-if="item1.CONTROL_Q==2 && item1.QUESTION_PK=='38' && thai_student==1"
                      label="POS_NAME"
                      :options="positionItems"
                      v-model="select_position1"
                      @input="selectPositionOnchange"
                      placeholder="พิมพ์คำค้นหา แล้วเลือก 'ชื่อตำแหน่ง' ที่ถูกต้องใน listbox"
                    ></v-select>
                    <b-form-input
                      v-if=" item1.QUESTION_PK=='38' && thai_student==0 "
                      id="current_position"
                      type="text"
                      autocomplete="current_position"
                      v-model="current_position"

                    ></b-form-input>
                    <b-form-input
                      v-if="item1.CONTROL_Q==1 && item1.QUESTION_PK=='39' "
                      id="current_skill"
                      type="text"
                      autocomplete="current_skill"
                      v-model="current_skill"
                      :state="validation_skill"
                    ></b-form-input>
                    <b-form-invalid-feedback :state="validation_skill"  v-if="item1.CONTROL_Q==1 && item1.QUESTION_PK=='39' ">
                      Your Spell must be 3-100 characters long.
                    </b-form-invalid-feedback>
                    <b-form-valid-feedback :state="validation_skill"  v-if="item1.CONTROL_Q==1 && item1.QUESTION_PK=='39' ">
                      Correct.
                    </b-form-valid-feedback>
<!--                    {{item1.QUESTION_PK}}-->
                    <b-form-radio-group
                      v-if="item1.QUESTION_PK==40"
                      v-model="selected_disclosure"
                      value-field="BYTECODE"
                      text-field="BYTEDES"
                      :options="item1s[3].ANS"
                      stacked
                      name="selected_disclosure"
                    >
<!--                       select:{{ selected_disclosure }}-->
                    </b-form-radio-group>
                    <b-form-radio-group
                      v-if="item1.QUESTION_PK==41"
                      v-model="selected_require_edu"
                      value-field="BYTECODE"
                      text-field="BYTEDES"
                      :options="item1s[4].ANS"
                      stacked
                      name="selected_require_edu"
                    >
                      <!-- select:{{ selected_require_edu }} -->
                    </b-form-radio-group>
                  </b-form-group>


                </div>
                <div slot="footer" class="text-center">
                  <b-button type="submit" size="md" class="mr-2" variant="success" @click="onBack">
                    <i class="fa fa-arrow-circle-o-left"></i> Back
                  </b-button>

                  <b-button type="submit" size="md" variant="primary" @click="onSubmit">
                    <i class="fa fa-dot-circle-o"></i> Submit
                  </b-button>
                  &nbsp&nbsp

                  <b-button type="reset" size="md" variant="danger" @click="onReset">
                    <i class="fa fa-ban"></i> Reset
                  </b-button>
                </div>
              </b-card>

              <b-card v-if="selected_workneed_id==2">
                <div slot="header" >
                  <strong v-if="thai_student==1" >ตอนที่ 3 สำหรับผู้ที่ยังไม่ได้ทำงาน <u>และทำงานต่างประเทศ</u></strong>
                  <strong v-else>Part 3 For graduates not yet employed <u>and Work in a foreign country</u></strong>
                </div>
                <div v-for="item1 in item1s" v-bind:key="item1.QUESTION_PK">
                  <b-form-group
                    class="text-danger"
                    v-if="(items2[item1.QUESTION_PK-34].VALUES ==2)"
                    :label="'*  ' +item1.NUMBER  + ') '+item1.QUESTION_NAME"
                    label-for="basicInlineRadios"
                    :label-cols="12"
                  ></b-form-group>
                  <b-form-group
                    v-else
                    :label="item1.NUMBER  + ') '+item1.QUESTION_NAME"
                    label-for="basicInlineRadios"
                    :label-cols="12"
                  ></b-form-group>

                  <b-form-group
                    label-cols-sm="1"
                    label
                    label-align-sm="right"
                    label-for="nested-street"
                  >
<!--                    <b-form-select-->
<!--                      v-if="item1.CONTROL_Q==2 && item1.QUESTION_PK=='37' "-->
<!--                      value-field="COUNTRYID"-->
<!--                      text-field="COUNTRYNAME"-->
<!--                      v-model="select_country"-->
<!--                      :stacked="true"-->
<!--                      :options="countryItems"-->
<!--                    ></b-form-select>-->
<!--                    {{ item1.CONTROL_Q }} {{ item1.QUESTION_PK }}-->
                    <v-select
                      v-if="item1.CONTROL_Q==2 && item1.QUESTION_PK=='37' "
                      label="FULL_NAME"
                      :options="countryItems"
                      v-model="select_country1"
                      :selected="current_country"
                      @input="selectCountryOnchange"
                      placeholder="พิมพ์คำค้นหา แล้วเลือก ' ชื่อประเทศ ' ถูกต้องใน listbox"
                    ></v-select>

                    <div v-if="item1.QUESTION_PK=='37'  && thai_student==1 ">{{ select_country }} {{
                        current_country
                      }}
                    </div>

                    <div v-if="item1.QUESTION_PK=='37'  ">
                      <!--                      select: {{ select_country }}-->
                    </div>
                    <!--                    <b-form-select-->
                    <!--                      v-if="item1.CONTROL_Q==2 && item1.QUESTION_PK=='32' && thai_student==1 "-->
                    <!--                      value-field="POS_ID"-->
                    <!--                      text-field="POS_NAME"-->
                    <!--                      size="md"-->
                    <!--                      :stacked="true"-->
                    <!--                      :options="positionItems"-->
                    <!--                      v-model="select_position1"-->
                    <!--                      v-on:change="selectPositionOnchange"-->
                    <!--                    ></b-form-select>-->
                    <v-select
                      v-if="item1.CONTROL_Q==2 && item1.QUESTION_PK=='38' && thai_student==1"
                      label="POS_NAME"
                      :options="positionItems"
                      v-model="select_position1"
                      :selected="current_position"
                      @input="selectPositionOnchange"
                      placeholder="พิมพ์คำค้นหา แล้วเลือก 'ชื่อตำแหน่ง' ที่ถูกต้องใน listbox"
                    ></v-select>
                    <div v-if="item1.QUESTION_PK=='38'  && thai_student==1 ">{{ select_position }} {{
                        current_position
                      }}
                    </div>
                    <b-form-input
                      v-if=" item1.QUESTION_PK=='38' && thai_student==0 "
                      id="current_position"
                      type="text"
                      autocomplete="current_position"
                      v-model="current_position"
                    ></b-form-input>
                    <b-form-input
                      v-if="item1.CONTROL_Q==1 && item1.QUESTION_PK=='39' "
                      id="current_skill"
                      type="text"
                      autocomplete="current_skill"
                      v-model="current_skill"
                    ></b-form-input>
                    <b-form-radio-group
                      v-if="item1.QUESTION_PK==40"
                      v-model="selected_disclosure"
                      value-field="BYTECODE"
                      text-field="BYTEDES"
                      :options="item1s[3].ANS"
                      stacked
                      name="selected_disclosure"
                    >
<!--                       select:{{ selected_disclosure }}-->
                    </b-form-radio-group>
                    <b-form-radio-group
                      v-if="item1.QUESTION_PK==41"
                      v-model="selected_require_edu"
                      value-field="BYTECODE"
                      text-field="BYTEDES"
                      :options="item1s[4].ANS"
                      stacked
                      name="selected_require_edu"
                    >
                      <!-- select:{{ selected_require_edu }} -->
                    </b-form-radio-group>
                  </b-form-group>
                </div>
                <div slot="footer" class="text-center">
                  <b-button type="submit" size="md" class="mr-2" variant="success" @click="onBack">
                    <i class="fa fa-arrow-circle-o-left"></i> Back
                  </b-button>

                  <b-button type="submit" size="md" variant="primary" @click="onSubmit">
                    <i class="fa fa-dot-circle-o"></i> Submit
                  </b-button>
                  &nbsp&nbsp

                  <b-button type="reset" size="md" variant="danger" @click="onReset">
                    <i class="fa fa-ban"></i> Reset
                  </b-button>
                </div>

              </b-card>
            </b-col>
          </b-row>
          <!-- <div slot="footer" class="text-center">
            <b-button type="submit" size="sm" variant="primary" @click="onSubmit">
              <i class="fa fa-dot-circle-o"></i> Submit
            </b-button>

            <b-button type="reset" size="sm" variant="danger" @click="onReset">
              <i class="fa fa-ban"></i> Reset
            </b-button>
          </div> -->
        </b-col>
      </b-row>
      <b-row>
        <b-col lg="6"></b-col>
      </b-row>
    </div>

    <b-modal v-if="thai_student==1"
             title="คุณกรอกข้อมูลไม่ครบถ้วน"
             class="modal-danger"
             v-model="dangerModal"
             @ok="dangerModal = false"
             ok-variant="danger"
    >{{ current_erorrtxt }}
    </b-modal>
    <b-modal v-if="thai_student==0"
             title="You didn’t fill your information completely"
             class="modal-danger"
             v-model="dangerModal"
             @ok="dangerModal = false"
             ok-variant="danger"
    >{{ current_erorrtxt }}
    </b-modal>
  </div>
</template>

<script>
import YimoVueEditor from "../../../node_modules/yimo-vue-editor/src/Editor.vue";
import api from "../../service/api";
import vSelect from "vue-select";
import "vue-select/dist/vue-select.css";

export default {
  components: {YimoVueEditor},
  name: "CreatePart3",
  data() {
    return {
      number: 0,
      items_findwork_eng: [
        {
          BYTECODE: "1",
          BYTEDES: "No"
        }, {
          BYTECODE: "2",
          BYTEDES: "Yes"
        }], items_findwork_thai: [
        {
          BYTECODE: "1",
          BYTEDES: "ไม่มีปัญหา"
        }, {
          BYTECODE: "2",
          BYTEDES: "มีปัญหา"
        }
      ],
      std_id: "",
      qn_income:"",
      student: {},
      thai_student: "",
      current_erorrtxt: "",
      actionUpdate:10,
      dangerModal: false,
      numEror: "",
      items: [],
      item1s: [],
      items2: [],
      selected_cause_nowork: "",
      qn_cause_nowork_txt: "",
      selected_workneed_id: "",
      current_country_name: "",
      countryItems: [],
      select_country: 41,
      select_country1: "",
      select_position: "",
      select_position1: "",
      positionItems: [],
      current_position: "",
      current_country:"",
      current_skill: "",
      selected_disclosure: "",
      selected_require_edu: "",
      selected_prob_findwork: "",
      selected_prob_findwork_0: "",
      selected_prob_findwork_1: "",
      selected_prob_findwork_2: "",
      selected_prob_findwork_3: "",
      selected_prob_findwork_4: "",
      selected_prob_findwork_5: "",
      selected_prob_findwork_6: "",
      selected_prob_findwork_7: "",
      selected_prob_findwork_8: "",
      selected_prob_findwork_9: "",
      selected_prob_findwork_10: "",
      selected_prob_findwork_11: "",
      selected_prob_findwork_12: "",
      selected_prob_findwork_13: "",
      selected_prob_findwork_14: "",
      selected_prob_findwork_20: "",
      qn_prob_findwork_txt: "",
      qn_work_status: "",
      numb: 0,
      length: 0
    };
  },
  // watch: {
  //   test: function() {
  //     console.log("t1 ", test);
  //   }
  // },
  components: {
    vSelect
  }, computed: {
    validation_skill() {
      var substring = "--";
      var zerochar = "00000";
      var substring00 = "00";
      var substring55 = "55555";
      var stringquestion = "??";
      var substring2="——";
      var substring3="__";
      var substring4="- -";
      var starstring="**";
      var pointstring='..';

      // if ((this.qn_occup_type_txt != null)) {
      if (this.current_skill != "" && this.current_skill != null && this.current_skill != undefined) {
        if (this.current_skill.toString().length > 0) {

          if (this.current_skill.includes(substring) || this.current_skill.includes(substring2)
            || this.current_skill.includes(substring3) || this.current_skill.includes(substring4)
            || this.current_skill.includes(substring4) || this.current_skill.includes(starstring)
            || this.current_skill.includes(pointstring)
          ) {
            return false;
          }
        }


        if (this.current_skill.length >= 3 && this.current_skill.length < 100) {
          if (this.current_skill.includes(substring) || this.current_skill.includes(zerochar)
            || this.current_skill.includes(substring00) || this.current_skill.includes(substring55)
            || this.current_skill.includes(stringquestion) || this.current_skill.includes(substring2)
            || this.current_skill.includes(substring3) || this.current_skill.includes(substring4)
            || this.current_skill.includes(substring4) || this.current_skill.includes(starstring)
            || this.current_skill.includes(pointstring)) {
            // console.log("f421")
            return false;
          } else {
            // console.log("f424")
            return true;
          }
        } else {
          // console.log("f428")
          return false;
        }
      } else {
        // console.log("f433")
        return false;
      }
    },
  },

  methods: {
    onBack() {
      this.$router.push("/Part1");
    },
    onchangeFindwork() {
      // console.log("f==",f)
      // console.log("x==", this.selected_prob_findwork_20)
    },
    getCurrentStudent(studentid) {
      api
        .getStudentGeneral(studentid)
        .then(res => {
          this.length = res.data.data.length;
          // console.log("res==", res);
          if (res.data.data.length == 1) {
            this.actionUpdate=1;
            var currentSt = res.data.data[0];
            this.std_id = this.student.STUDENTID;
            this.qn_income = currentSt.QN_INCOME;
            if (this.qn_income == 1 || this.qn_income == 2) { //เฉพาะ 3+4 เช้า part 3
              this.$router.push("/general");
            }
            this.selected_cause_nowork = currentSt.QN_CAUSE_NOWORK;
            this.qn_cause_nowork_txt = currentSt.QN_CAUSE_NOWORK_TXT;

            this.qn_prob_findwork_txt = currentSt.QN_PROB_FINDWORK_TXT;
            // console.log("QN_PROB_FINDWORK==",currentSt.QN_PROB_FINDWORK)
            var selectedData = [];
            var j = -1;
            if (currentSt.QN_PROB_FINDWORK == 1) {
              // console.log("111111111111")
              this.selected_prob_findwork_20 = currentSt.QN_PROB_FINDWORK;
            } else {
              if (currentSt.QN_PROB_FINDWORK == 2) {
                this.selected_prob_findwork_20 = 2;
              } else {
                this.selected_prob_findwork_20 = null;
              }

              if (currentSt.QN_PROB_FINDWORK0 != null) {
                j = j + 1;
                selectedData[j] = 0;
              }
              if (currentSt.QN_PROB_FINDWORK != null) {
                j = j + 1;
                selectedData[j] = 1;
              }
              if (currentSt.QN_PROB_FINDWORK2 != null) {
                j = j + 1;
                selectedData[j] = 2;
              }
              if (currentSt.QN_PROB_FINDWORK3 != null) {
                j = j + 1;
                selectedData[j] = 3;
              }
              if (currentSt.QN_PROB_FINDWORK4 != null) {
                j = j + 1;
                selectedData[j] = 4;
              }
              if (currentSt.QN_PROB_FINDWORK5 != null) {
                j = j + 1;
                selectedData[j] = 5;
              }
              if (currentSt.QN_PROB_FINDWORK6 != null) {
                j = j + 1;
                selectedData[j] = 6;
              }
              if (currentSt.QN_PROB_FINDWORK7 != null) {
                j = j + 1;
                selectedData[j] = 7;
              }
              if (currentSt.QN_PROB_FINDWORK8 != null) {
                j = j + 1;
                selectedData[j] = 8;
              }
              if (currentSt.QN_PROB_FINDWORK9 != null) {
                j = j + 1;
                selectedData[j] = 9;
              }
              if (currentSt.QN_PROB_FINDWORK10 != null) {
                j = j + 1;
                selectedData[j] = 10;
              }
              if (currentSt.QN_PROB_FINDWORK11 != null) {
                j = j + 1;
                selectedData[j] = 11;
              }
              if (currentSt.QN_PROB_FINDWORK12 != null) {
                j = j + 1;
                selectedData[j] = 12;
              }
              if (currentSt.QN_PROB_FINDWORK13 != null) {
                j = j + 1;
                selectedData[j] = 13;
              }
              if (currentSt.QN_PROB_FINDWORK14 != null) {
                j = j + 1;
                selectedData[j] = 14;
              }
              this.selected_prob_findwork = selectedData;
              this.selected_prob_findwork_0 = currentSt.QN_PROB_FINDWORK0;
              // this.selected_prob_findwork_1 = currentSt.QN_PROB_FINDWORK;
              this.selected_prob_findwork_2 = currentSt.QN_PROB_FINDWORK2;
              this.selected_prob_findwork_3 = currentSt.QN_PROB_FINDWORK3;
              this.selected_prob_findwork_4 = currentSt.QN_PROB_FINDWORK4;
              this.selected_prob_findwork_5 = currentSt.QN_PROB_FINDWORK5;
              this.selected_prob_findwork_6 = currentSt.QN_PROB_FINDWORK6;
              this.selected_prob_findwork_7 = currentSt.QN_PROB_FINDWORK7;
              this.selected_prob_findwork_8 = currentSt.QN_PROB_FINDWORK8;
              this.selected_prob_findwork_9 = currentSt.QN_PROB_FINDWORK9;
              this.selected_prob_findwork_10 = currentSt.QN_PROB_FINDWORK10;
              this.selected_prob_findwork_11 = currentSt.QN_PROB_FINDWORK11;
              this.selected_prob_findwork_12 = currentSt.QN_PROB_FINDWORK12;
              this.selected_prob_findwork_13 = currentSt.QN_PROB_FINDWORK13;
              this.selected_prob_findwork_14 = currentSt.QN_PROB_FINDWORK14;
            }
            this.selected_workneed_id = currentSt.QN_WORKNEED_ID;
            this.select_country = currentSt.QN_WORKNEED_NATION;
            this.current_country=currentSt.QN_WORKNEED_NATION_NAME;
            this.select_position = currentSt.QN_WORKNEED_POSITION;
            if (this.thai_student == 1) {
              // console.log("select_position==",currentSt.QN_WORKNEED_POSITION )
              this.select_position = currentSt.QN_WORKNEED_POSITION;
              this.current_position = currentSt.QN_WORKNEED_POSITION_ENG;
              this.select_position1 = currentSt.QN_WORKNEED_POSITION_ENG;
            } else {
              this.select_position = "";
              this.current_position = currentSt.QN_WORKNEED_POSITION_ENG;
            }
            this.current_skill = currentSt.QN_SKILL_DEVELOPMENT;
            this.selected_disclosure = currentSt.QN_DISCLOSURE_AGREEMENT_ID;
            this.selected_require_edu = currentSt.QN_REQUIRE_EDU;
          } else {
            this.actionUpdate=0;
          }
          return this.actionUpdate;
        })
        .catch(err => {
          this.actionUpdate=10;
          console.log("getCurrentStudent", err.toString());
          this.$router.push("login");
        });
    },
    getStudentQuestion() {
      this.std_id = this.$store.state.user.studentid;
      this.stdstudentId = this.$store.state.user.studentid;
      this.thai_student = this.$store.state.user.thaistudent;
      // console.log("xx=",this.$store.state.user)
      this.sex = this.$store.state.user.sex;
      this.getCurrentStudent(this.std_id);
      this.getQuestion(3, this.sex, this.thai_student);
      this.getQuestion(31, this.sex, this.thai_student);
      this.getCountry(this.thai_student);
      if (this.thai_student == 1) {
        this.getPosition();
      }
    },
    checkQuotation(s) {
      var quotation1 = "'";
      var quotation2 = "`";
      if (s.qn_cause_nowork_txt != '' && s.qn_cause_nowork_txt != null && s.qn_cause_nowork_txt != undefined) {
        if (s.qn_cause_nowork_txt.toString().length > 0) {
          if (s.qn_cause_nowork_txt.toString().includes(quotation1)) {
            s.qn_cause_nowork_txt = s.qn_cause_nowork_txt.replaceAll(quotation1, "''");
          }
          if (s.qn_cause_nowork_txt.toString().includes(quotation2)) {
            s.qn_cause_nowork_txt = s.qn_cause_nowork_txt.replaceAll(quotation2, "''");
          }
        }
      }
      if (s.qn_prob_findwork_txt != '' && s.qn_prob_findwork_txt != null && s.qn_prob_findwork_txt != undefined) {
        if (s.qn_prob_findwork_txt.toString().length > 0) {
          if (s.qn_prob_findwork_txt.toString().includes(quotation1)) {
            s.qn_prob_findwork_txt = s.qn_prob_findwork_txt.replaceAll(quotation1, "''");
          }
          if (s.qn_prob_findwork_txt.toString().includes(quotation2)) {
            s.qn_prob_findwork_txt = s.qn_prob_findwork_txt.replaceAll(quotation2, "''");
          }
        }
      }
      if (s.current_skill != '' && s.current_skill != null && s.current_skill != undefined) {
        if (s.current_skill.toString().length > 0) {
          if (s.current_skill.toString().includes(quotation1)) {
            s.current_skill = s.current_skill.replaceAll(quotation1, "''");
          }
          if (s.current_skill.toString().includes(quotation2)) {
            s.current_skill = s.current_skill.replaceAll(quotation2, "''");
          }
        }
      }

      return s;
    },
    getErrorTxt: function (s) {
      this.current_erorrtxt = "";
      this.numEror = 0;
      var substring = "--";
      var substring1 = "..";
      var substring2="——";
      var substring3="__";
      var substring4="- -";
      var starstring="**";
      var pointstring='..';
      var student  =this.checkQuotation(s);
      if ((this.selected_cause_nowork == null) || (this.selected_cause_nowork == "") || (this.selected_cause_nowork == undefined)) {
        this.numEror = this.numEror + 1;
        this.items2[0].VALUES = 2;
        this.current_erorrtxt = this.thai_student == "1" ? this.current_erorrtxt + "/สาเหตุที่ยังไม่ได้ทำงาน" : this.current_erorrtxt + "/Cause nowork";
      } else {
        if ((this.selected_cause_nowork == 0) && ((this.qn_cause_nowork_txt == "")
          || (this.qn_cause_nowork_txt == "None") || (this.qn_cause_nowork_txt == null)
          || (this.qn_cause_nowork_txt == "-") || (this.qn_cause_nowork_txt == "--")
          || (this.qn_cause_nowork_txt == "."))) {
          this.numEror = this.numEror + 1;
          this.items2[0].VALUES = 2;
          this.current_erorrtxt = this.thai_student == "1" ? this.current_erorrtxt + "/อื่นๆ ระบุ" : this.current_erorrtxt + "/Other";
        } else if ((this.selected_cause_nowork == 0) && (this.qn_cause_nowork_txt != "")) {
          if (this.qn_cause_nowork_txt.includes(substring)) {
            this.numEror = this.numEror + 1;
            this.items2[0].VALUES = 2;
            this.current_erorrtxt = this.thai_student == "1" ? this.current_erorrtxt + "/อื่นๆ ระบุ --" : this.current_erorrtxt + "/Other --";
          }
          if (this.qn_cause_nowork_txt.includes(substring1)) {
            this.numEror = this.numEror + 1;
            this.items2[0].VALUES = 2;
            this.current_erorrtxt = this.thai_student == "1" ? this.current_erorrtxt + "/อื่นๆ ระบุ --" : this.current_erorrtxt + "/Other --";
          }
        }
      }


      if ((this.selected_prob_findwork_0 == 1) && ((this.qn_prob_findwork_txt == "") || (this.qn_prob_findwork_txt == null) || (this.qn_prob_findwork_txt == "-") || (this.qn_prob_findwork_txt == "--"))) {
        this.numEror = this.numEror + 1;
        this.items2[1].VALUES = 2;
        this.current_erorrtxt = this.thai_student == "1" ? this.current_erorrtxt + "/อื่นๆ ระบุ " : this.current_erorrtxt + "/Other";
      } else if ((this.selected_prob_findwork_0 == 1) && (this.qn_prob_findwork_txt != "")) {
        if (this.qn_prob_findwork_txt.includes(substring)) {
          this.numEror = this.numEror + 1;
          this.items2[1].VALUES = 2;
          this.current_erorrtxt = this.thai_student == "1" ? this.current_erorrtxt + "/อื่นๆ ระบุ --" : this.current_erorrtxt + "/Other --";
        }
        if (this.qn_prob_findwork_txt.includes(substring1)) {
          this.numEror = this.numEror + 1;
          this.items2[1].VALUES = 2;
          this.current_erorrtxt = this.thai_student == "1" ? this.current_erorrtxt + "/อื่นๆ ระบุ --" : this.current_erorrtxt + "/Other --";
        }

      }
      if ((this.selected_prob_findwork_20 == "") || (this.selected_prob_findwork_20 == null) || (this.selected_prob_findwork_20 == undefined)) {
        this.numEror = this.numEror + 1;
        this.items2[1].VALUES = 2;
        this.current_erorrtxt = this.thai_student == "1" ? this.current_erorrtxt + "/ปัญหาในการหางาน" : this.current_erorrtxt + "/Problem findwork";
      } else if (this.selected_prob_findwork_20 == 2) {
        if (this.selected_prob_findwork == null || this.selected_prob_findwork == "") {
          this.numEror = this.numEror + 1;
          this.items2[1].VALUES = 2;
          this.current_erorrtxt = this.thai_student == "1" ? this.current_erorrtxt + "/ปัญหาในการหางาน" : this.current_erorrtxt + "/If yes, please choose the reasons. You can choose more than one answer";
        }
      }
      /*if (this.selected_prob_findwork_0 == 1 && this.qn_prob_findwork_txt == "") {
        this.numEror = this.numEror + 1;
        this.current_erorrtxt =this.thai_student == "1" ? this.current_erorrtxt + "/อื่นๆ ระบุ": this.current_erorrtxt + "/Other";
      }*/

      if ((this.selected_workneed_id == null) || (this.selected_workneed_id == "") || (this.selected_workneed_id == undefined)) {
        this.numEror = this.numEror + 1;
        this.items2[2].VALUES = 2;
        this.current_erorrtxt = this.thai_student == "1" ? this.current_erorrtxt + "/ความต้องการทำงาน" : this.current_erorrtxt + "/Work need";
      }
      if (this.selected_workneed_id == 2) {
        console.log("select_country1==",this.select_country1)
        if (this.select_country1 == null || this.select_country1 == "" || this.select_country1 == 0) {
          this.numEror = this.numEror + 1;
          this.items2[3].VALUES = 2;
          this.current_erorrtxt = this.thai_student == "1" ? this.current_erorrtxt + "/ประเทศที่ต้องการทำงาน" : this.current_erorrtxt + "/Country";
        }
      }
      if (this.thai_student == 1) {
        if (this.select_position == null || this.select_position == "" || this.select_position == 0 || this.select_position == undefined) {
          this.numEror = this.numEror + 1;
          this.items2[4].VALUES = 2;
          this.current_erorrtxt = this.thai_student == "1" ? this.current_erorrtxt + "/ตำแหน่งที่ต้องการทำงาน" : this.current_erorrtxt + "/Position";
        }
      } else {
        if (this.current_position == null || this.current_position == "" || this.current_position == "None"
          || this.current_position == 0 || this.current_position == "-" || this.current_position == undefined
          || this.current_position == "--" || this.current_position == ".") {
          this.numEror = this.numEror + 1;
          this.items2[4].VALUES = 2;
          this.current_erorrtxt = this.thai_student == "1" ? this.current_erorrtxt + "/ตำแหน่งที่ต้องการทำงาน" : this.current_erorrtxt + "/Position";
        } else {
          if (this.current_position.includes(substring)) {
            this.numEror = this.numEror + 1;
            this.items2[4].VALUES = 2;
            this.current_erorrtxt = this.thai_student == "1" ? this.current_erorrtxt + "/ตำแหน่งที่ต้องการทำงาน --" : this.current_erorrtxt + "/Position --";
          }
          if (this.current_position.includes(substring1)) {
            this.numEror = this.numEror + 1;
            this.items2[4].VALUES = 2;
            this.current_erorrtxt = this.thai_student == "1" ? this.current_erorrtxt + "/ตำแหน่งที่ต้องการทำงาน --" : this.current_erorrtxt + "/Position --";
          }
        }
      }
      //console.log("xx==",this.current_skill)
      if (this.current_skill == null || this.current_skill == "" || this.current_skill == 0
        || this.current_skill == "-" || this.current_skill == "- "|| this.current_skill == " -"
        || this.current_skill == "--" || this.current_skill == "---"
        || this.current_skill == "."|| this.current_skill == "/") {

        this.numEror = this.numEror + 1;
        this.items2[5].VALUES = 2;
        this.current_erorrtxt = this.thai_student == "1" ? this.current_erorrtxt + "/ความต้องการพัฒนาทักษา" : this.current_erorrtxt + "/Skill";
      } else {
        if (this.current_skill.toString().length > 0) {
          if (this.current_skill.includes(substring) || this.current_skill.includes(substring2)
            || this.current_skill.includes(substring3) || this.current_skill.includes(substring4)
            || this.current_skill.includes(substring4) || this.current_skill.includes(starstring)
            || this.current_skill.includes(pointstring)
          ) {
            this.numEror = this.numEror + 1;
            this.items2[5].VALUES = 2;
            this.current_erorrtxt = this.thai_student == "1" ? this.current_erorrtxt + "/ความต้องการพัฒนาทักษา --" : this.current_erorrtxt + "/Skill --";
          }
          if (this.current_skill.includes(substring1)) {
            this.numEror = this.numEror + 1;
            this.items2[5].VALUES = 2;
            this.current_erorrtxt = this.thai_student == "1" ? this.current_erorrtxt + "/ความต้องการพัฒนาทักษา --" : this.current_erorrtxt + "/Skill --";
          }
        }
      }
      if ((this.selected_disclosure == null) || (this.selected_disclosure == "") || (this.selected_disclosure == undefined)) {
        this.numEror = this.numEror + 1;
        this.items2[6].VALUES = 2;
        this.current_erorrtxt = this.thai_student == "1" ? this.current_erorrtxt + "/การเปิดเผยข้อมูล" : this.current_erorrtxt + "/Disclosure";
      }
      if (this.selected_require_edu == null || this.selected_require_edu == "" || this.selected_require_edu == undefined) {
        this.numEror = this.numEror + 1;
        this.items2[7].VALUES = 2;
        this.current_erorrtxt = this.thai_student == "1" ? this.current_erorrtxt + "/ความต้องการศึกษาต่อ" : this.current_erorrtxt + "/Require Education";
      }


      if (this.numEror == 0) {
        this.dangerModal = false;
      } else {
        this.dangerModal = true;
      }
      student.num_error= this.numEror;
      return student;
    },
    nextPart() {
      // console.log("selected_require_edu ==", this.selected_require_edu);
      if (this.actionUpdate == false) {
        this.$router.push("/General");
      } else {
        // if (this.selected_workneed_id==1){
        //       this.$router.push("/Part5"); ผิดตรงนี้ เพราะต้องดูว่าจะเรียนต่อด้วยหรือไม่
        // }else{
        //   if (this.selected_require_edu==1){
        //       this.$router.push("/Part4");
        //   }else if (this.selected_require_edu==2){
        //       this.$router.push("/Part5");
        //   }
        // }
        if (this.selected_workneed_id == 1) {
          this.number = this.number - 1;
        }
        if (this.selected_require_edu == 1) {
          this.$router.push("/part4?x=" + this.number);
        } else if (this.selected_require_edu == 2) {
          this.$router.push("/part5?x=" + this.number);
        }


      }


    },
    onUpdateData(student) {
      api
        .updateStudentPart3(student)
        .then(res => {
          // console.log(res);
          this.message = res.message;
          // console.log("updateStudentPart3 ผ่าน", this.studentId);
          // console.log("selected_require_edu ==", this.selected_require_edu);
          // console.log("selected_require_edu ==", this.selected_require_edu);
          this.nextPart();
        })
        .catch(err => {
          console.log("updatePart3 error", err.toString());
        });
    },
    onReset() {
      // this.selected_cause_nowork="";
      // this.qn_cause_nowork_txt="";
      // this.selected_prob_findwork="";
      // this.qn_prob_findwork_txt="";
      // this.selected_prob_findwork_0="";
      // this.selected_prob_findwork_1="";
      // this.selected_prob_findwork_2="";
      // this.selected_prob_findwork_3="";
      // this.selected_prob_findwork_4="";
      // this.selected_prob_findwork_5="";
      // this.selected_prob_findwork_6="";
      // this.selected_prob_findwork_7="";
      // this.selected_prob_findwork_8="";
      // this.selected_prob_findwork_9="";
      // this.selected_prob_findwork_10="";
      // this.selected_prob_findwork_11="";
      // this.selected_prob_findwork_12="";
      // this.selected_prob_findwork_13="";
      // this.selected_prob_findwork_14="";
      // this.selected_workneed_id="";
      // select_country ="";
      this.current_position = "";
      this.current_skill = "";
      this.selected_disclosure = "";
      this.selected_require_edu = "";
    },
    onSubmit() {
      // console.log("numEror", this.numEror);
      var student={};
      student =this.setStudent();
      var s = this.getErrorTxt(student);
      if (s.num_error == 0) {
        if (this.actionUpdate == 0) {
          this.$router.push("/General");
        } else {
          this.onUpdateData(s);
        }
      }
    },
    setStudent: function () {
      var student ={};
      student.std_id = this.$store.state.user.studentid;
      student.qn_year=this.$store.state.user.year;
      student.selected_cause_nowork = this.selected_cause_nowork;
      if (this.selected_cause_nowork == 0) {
        student.qn_cause_nowork_txt = this.qn_cause_nowork_txt
        //.replaceAll( "'", "`");
      } else {
        student.qn_cause_nowork_txt = "";
      }
      if ((this.selected_cause_nowork == null) || (this.selected_cause_nowork == '') || (this.selected_cause_nowork == undefined)) {
        this.items2[0].VALUES = 2;
      } else {
        if ((this.selected_cause_nowork == 0) && ((this.qn_cause_nowork_txt == null) || (this.qn_cause_nowork_txt == '') || (this.qn_cause_nowork_txt == undefined))) {
          this.items2[0].VALUES = 2;
        } else {
          this.items2[0].VALUES = 1;
        }
      }
      if (this.selected_prob_findwork_20 == 1) {
        student.selected_prob_findwork_1 = 1;
        this.selected_prob_findwork_1 = 1;
        student.selected_prob_findwork_0 = "";
        this.selected_prob_findwork_0 = "";
        student.qn_prob_findwork_txt = "";
        student.selected_prob_findwork_2 = "";
        this.selected_prob_findwork_2 = "";
        student.selected_prob_findwork_3 = "";
        this.selected_prob_findwork_3 = "";
        student.selected_prob_findwork_4 = "";
        this.selected_prob_findwork_4 = "";
        student.selected_prob_findwork_5 = "";
        this.selected_prob_findwork_5 = "";
        student.selected_prob_findwork_6 = "";
        this.selected_prob_findwork_6 = "";
        student.selected_prob_findwork_7 = "";
        this.selected_prob_findwork_7 = "";
        student.selected_prob_findwork_8 = "";
        this.selected_prob_findwork_8 = "";
        student.selected_prob_findwork_9 = "";
        this.selected_prob_findwork_9 = "";
        student.selected_prob_findwork_10 = "";
        this.selected_prob_findwork_10 = "";
        student.selected_prob_findwork_11 = "";
        this.selected_prob_findwork_11 = "";
        student.selected_prob_findwork_12 = "";
        this.selected_prob_findwork_12 = "";
        student.selected_prob_findwork_13 = "";
        this.selected_prob_findwork_13 = "";
        student.selected_prob_findwork_14 = "";
        this.selected_prob_findwork_14 = "";
      } else {
        student.selected_prob_findwork_0 = "";
        this.selected_prob_findwork_0 = "";
        student.qn_prob_findwork_txt = "";
        student.selected_prob_findwork_1 = "";
        this.selected_prob_findwork_1 = "";
        student.selected_prob_findwork_2 = "";
        this.selected_prob_findwork_2 = "";
        student.selected_prob_findwork_3 = "";
        this.selected_prob_findwork_3 = "";
        student.selected_prob_findwork_4 = "";
        this.selected_prob_findwork_4 = "";
        student.selected_prob_findwork_5 = "";
        this.selected_prob_findwork_5 = "";
        student.selected_prob_findwork_6 = "";
        this.selected_prob_findwork_6 = "";
        student.selected_prob_findwork_7 = "";
        this.selected_prob_findwork_7 = "";
        student.selected_prob_findwork_8 = "";
        this.selected_prob_findwork_8 = "";
        student.selected_prob_findwork_9 = "";
        this.selected_prob_findwork_9 = "";
        student.selected_prob_findwork_10 = "";
        this.selected_prob_findwork_10 = "";
        student.selected_prob_findwork_11 = "";
        this.selected_prob_findwork_11 = "";
        student.selected_prob_findwork_12 = "";
        this.selected_prob_findwork_12 = "";
        student.selected_prob_findwork_13 = "";
        this.selected_prob_findwork_13 = "";
        student.selected_prob_findwork_14 = "";
        this.selected_prob_findwork_14 = "";
        for (var i = 0; i < this.selected_prob_findwork.length; i++) {
          // console.log("length==", this.selected_prob_findwork.length);
          var ans_addprogram = this.selected_prob_findwork[i];
          if (ans_addprogram == "0") {
            student.selected_prob_findwork_0 = 1;
            this.selected_prob_findwork_0 = 1;
            student.qn_prob_findwork_txt = this.qn_prob_findwork_txt
            //.replaceAll( "'", "`");
          } else if (ans_addprogram == "2") {
            student.selected_prob_findwork_2 = 1;
            this.selected_prob_findwork_2 = 1;
          } else if (ans_addprogram == "3") {
            student.selected_prob_findwork_3 = 1;
            this.selected_prob_findwork_3 = 1;
          } else if (ans_addprogram == "4") {
            student.selected_prob_findwork_4 = 1;
            this.selected_prob_findwork_4 = 1;
          } else if (ans_addprogram == "5") {
            student.selected_prob_findwork_5 = 1;
            this.selected_prob_findwork_5 = 1;
          } else if (ans_addprogram == "6") {
            student.selected_prob_findwork_6 = 1;
            this.selected_prob_findwork_6 = 1;
          } else if (ans_addprogram == "7") {
            student.selected_prob_findwork_7 = 1;
            this.selected_prob_findwork_7 = 1;
          } else if (ans_addprogram == "8") {
            student.selected_prob_findwork_8 = 1;
            this.selected_prob_findwork_8 = 1;
          } else if (ans_addprogram == "9") {
            student.selected_prob_findwork_9 = 1;
            this.selected_prob_findwork_9 = 1;
          } else if (ans_addprogram == "10") {
            student.selected_prob_findwork_10 = 1;
            this.selected_prob_findwork_10 = 1;
          } else if (ans_addprogram == "11") {
            student.selected_prob_findwork_11 = 1;
            this.selected_prob_findwork_11 = 1;
          } else if (ans_addprogram == "12") {
            student.selected_prob_findwork_12 = 1;
            this.selected_prob_findwork_12 = 1;
          } else if (ans_addprogram == "13") {
            student.selected_prob_findwork_13 = 1;
            this.selected_prob_findwork_13 = 1;
          } else if (ans_addprogram == "14") {
            student.selected_prob_findwork_14 = 1;
            this.selected_prob_findwork_14 = 1;
          }
        }
      }
      if (this.selected_prob_findwork.length == 0) {
        if (this.selected_prob_findwork_20 == 1) {
          this.items2[1].VALUES = 1;
        } else {
          this.items2[1].VALUES = 2;
        }
      } else {
        this.items2[1].VALUES = 1;
      }

      student.selected_workneed_id = this.selected_workneed_id;
      if ((this.selected_workneed_id == null) || (this.selected_workneed_id == '') || (this.selected_workneed_id == undefined)) {
        this.items2[2].VALUES = 2;
      } else {
        this.items2[2].VALUES = 1;
      }
      if (this.thai_student == 1) {
        student.select_position = this.select_position;
        student.current_position = this.current_position;
        if ((this.select_position == null) || (this.select_position == '') || (this.select_position == undefined)) {
          this.items2[4].VALUES = 2;
        } else {
          this.items2[4].VALUES = 1;
        }
        // console.log("ไทย==",this.thai_student)
        // console.log("ตำแหน่ง",this.select_position,"==",this.current_position)
      } else {
        student.select_position = "";
        student.current_position = this.current_position
        //.replaceAll( "'", "`");
        if ((this.current_position == null) || (this.current_position == '') || (this.current_position == undefined)) {
          this.items2[4].VALUES = 2;
        } else {
          this.items2[4].VALUES = 1;
        }
      }
      if (this.selected_workneed_id == 2) { //ทำงานต่างประเทศ
        student.select_country = this.select_country;
        student.current_country_name=this.current_country_name;
        if ((this.select_country == null) || (this.select_country == '') || (this.select_country == undefined)) {
          this.items2[3].VALUES = 2;
        } else {
          this.items2[3].VALUES = 1;
        }
      } else if (this.selected_workneed_id == 1) { //ทำงานในประเทศ
        student.select_country = "";
        student.current_country_name="";
      }

      student.current_skill = this.current_skill
      //.replaceAll( "'", "`");
      if ((this.current_skill == null) || (this.current_skill == '') || (this.current_skill == undefined)) {
        this.items2[5].VALUES = 2;
      } else {
        this.items2[5].VALUES = 1;
      }
      student.selected_disclosure = this.selected_disclosure;
      if ((this.selected_disclosure == null) || (this.selected_disclosure == '') || (this.selected_disclosure == undefined)) {
        this.items2[6].VALUES = 2;
      } else {
        this.items2[6].VALUES = 1;
      }
      student.selected_require_edu = this.selected_require_edu;

      if ((this.selected_require_edu == null) || (this.selected_require_edu == '') || (this.selected_require_edu == undefined)) {
        this.items2[7].VALUES = 2;
      } else {
        this.items2[7].VALUES = 1;
      }
      // student.select_position = "";
      // student.current_position = "";
      // student.current_skill = "";
      // student.selected_disclosure = "";
      // student.selected_require_edu="";
      // console.log("Setstudent==", student);
      return student;
    },
    getStudentAns() {
    },
    getQuestion: function (section, sex, thaistudent) {
      api
        .getQuestionBySection(section, sex, thaistudent)
        .then(res => {
          var number, number1, number2,start2;
          var x = this.$route.query.x;
          // console.log("x==", isNaN(x));
          if (isNaN(x) || x <= 0) {
            number = 0;
          } else {
            number = parseInt(x);
          }
          // number = x > 0 ? x : 0;
          start2=number+3
          // console.log("คำถาม==",res)
          if (section == 3) {
            for (var i = 0; i < res.data.data.length; i++) {
              number = number + 1;
              res.data.data[i].NUMBER = number;
            }
            this.items = res.data.data;
            // console.log("คำถาม1==",this.items)
            this.number = number;
          } else if (section == 31) {
            number2 = start2;
            for (var i = 0; i < res.data.data.length; i++) {
              number2 = number2 + 1;
              res.data.data[i].NUMBER2=number2-1;
              res.data.data[i].NUMBER = number2;
            }
            this.item1s = res.data.data;
            this.number = number2;
            // console.log(this.item1s);
            // console.log("คำถาม2==",this.item1s)
          }
        })
        .catch(err => {
          console.log("2 getQuestionBySection", err.toString());
        });
    },
    getCountry(thaistudent) {
      api
        // .getCountryAll(thaistudent)
        .getCountryNoThai(thaistudent)
        .then(res => {
          // console.log("thaistudent==",thaistudent);
          this.countryItems = res.data.data;
          // console.log("", res.data.data);
        })
        .catch(err => {
          console.log(2);
          console.log("2", err.toString());
        });
    },
    selectCountryOnchange:function (e){
      console.log("selectNationOnchange",e);
      this.select_country = e.COUNTRYID;
      this.current_country_name = e.COUNTRY_ENG;
      this.current_country = e.COUNTRYNAME ;
      console.log("หลัง",this.select_country ,this.current_country_name,this.current_country);

    },
    selectPositionOnchange: function () {

      this.select_position = this.select_position1.POS_ID;
      this.select_position_eng = this.select_position1.POS_NAME;
      this.current_position = this.select_position_eng;
      // console.log("select_position", this.select_position);
      // console.log("select_position_eng", this.select_position_eng);
      // api
      // api
      //   .getPositionById(this.select_position)
      //   .then(res => {
      //     console.log(
      //       "getPositionById ==",
      //       res.data.data[0].POS_NAME
      //     );
      //     this.current_position = res.data.data[0].POS_NAME;
      //   })
      //   .catch(err => {
      //     console.log(2);
      //     console.log("2", err.toString());
      //   });
    },
  /*  selectCountryOnchange: function () {
      api
        .getCountryById(this.select_country)
        .then(res => {
          console.log(
            "685COUNTRYNAME selectCountryOnchange ==",
            res.data.data[0].COUNTRYNAME
          );
          this.current_country_name = res.data.data[0].COUNTRYNAME;
        })
        .catch(err => {
          console.log(2);
          console.log("2", err.toString());
        });
    },*/
  /*  getCountryId: function (countryid) {
      api
        .getCountryById(countryid)
        .then(res => {
          this.current_country_name = res.data.data[0].COUNTRYNAME;
          console.log("697COUNTRYNAME==", this.current_country_name);
          return this.current_country_name;
        })
        .catch(err => {
          console.log(2);
          console.log("2", err.toString());
          return "";
        });
    }, */
    getPosition() {
      api
        .getPositionAll()
        .then(res => {
          this.positionItems = res.data.data;
          // console.log("positionItems==", res.data.data);
        })
        .catch(err => {

          console.log("getPositionAll", err.toString());
        });
    }
  },
  mounted() {
  },
  created() {

    for (var j = 34; j <= 41; j++) {
      var b = {ID: j, UPDATEDATA: 0, VALUES: 0}
      this.items2.push(b);
    }
    // console.log("==", this.items2)
    if (this.$store.state.token == null || this.$store.state.user == null) {
      this.$router.push("/Login");
    } else {
      // this.$router.push("/Dashboard");
    }

    this.std_id = this.$store.state.user.studentid;
    api.onSetHeader();
    this.actionUpdate = this.getCurrentStudent(this.std_id);
    this.getStudentQuestion();


  }
};
</script>
<style>
</style>
